











































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { ja } from 'vuejs-datepicker/dist/locale'
import { MetaInfo } from 'vue-meta'
import { common } from '@/app/model/store/domain/const'

/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'

/* module */
import CommonClass from '@/app/module/common'
import ExternalLinkContentValidator from '@/app/module/validator/externalLinkContentValidator'
import ExternalLinkDetailApi from '@/app/model/api/externalLinkDetailApi'
import ExternalLinkContentCreateApi from '@/app/model/api/externalLinkContentCreateApi'
import ExternalLinkContentDetailApi from '@/app/model/api/externalLinkContentDetailApi'
import ExternalLinkContentEditApi from '@/app/model/api/externalLinkContentEditApi'
import ExternalLinkContentDeleteApi from '@/app/model/api/externalLinkContentDeleteApi'
import GetExternalLinkFileApi from '@/app/model/api/getExternalLinkFileApi'

import Datepicker from 'vuejs-datepicker'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    Loading,
    Error409Modal,
    DeleteModal,
    ErrorModal,
    ErrorInfo,
    Datepicker
  },
  metaInfo (this: ExternalLinkContentCreate): MetaInfo {
    return {
      title: this.setPageTitle
    }
  }
})
export default class ExternalLinkContentCreate extends Vue {
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  private externalLinkName: string = ''
  private externalLinkContentName: string = ''
  private externalLinkId: string = ''
  private externalLinkContentId: string = ''
  private externalLinkContentDate: any = new Date()
  private contentURL: string = ''

  /* 表示非表示 */
  private showLoading: boolean = true
  private showServerErrorModal: boolean = false
  private showConfirmationModal: boolean = false
  private showError409Modal: boolean = false
  private show400ErrorMessage: boolean = false
  private createModeFlag: boolean = true

  private contentOptions: any = [
    { text: 'ファイル', value: 0 },
    { text: 'URL', value: 1 }
  ]
  private contentSelected: number = 0
  private externalLinkDetailData: any = {}
  private externalLinkContentDetailData: any = {}
  private uploadFile: any = null
  private remarks: string = ''
  private japanese: any = ja
  private fileName: string = ''
  private externalLinkTitle: string = ''
  private externalLinkHeaderTitle: string = ''

  private get setPageTitle () {
    let title = ''
    if (this.$route.path === '/external-link/' + this.externalLinkId + '/content/create') {
      title = CommonClass.getServiceFunctionData().external_link.external_link_name + '記事追加 | ' + common.SYSTEM_NAME
    } else {
      title = CommonClass.getServiceFunctionData().external_link.external_link_name + '記事編集・削除 | ' + common.SYSTEM_NAME
    }
    return title
  }

  created () {
    this.externalLinkTitle = CommonClass.getServiceFunctionData().external_link.external_link_name
    this.externalLinkId = this.$route.params.external_link_id
    this.getExternalLinkDetail(this.externalLinkId)

    const path = '/external-link/' + this.externalLinkId + '/content/create'
    if (this.$route.path === path) {
      this.externalLinkHeaderTitle = this.externalLinkTitle + '連携追加'
      this.createModeFlag = true
    } else {
      this.externalLinkHeaderTitle = this.externalLinkTitle + '連携編集・削除'
      this.createModeFlag = false
      this.externalLinkContentId = this.$route.params.external_link_content_id
      this.getExternalLinkContentDetail(this.externalLinkContentId)
    }
  }

  private saveExternalLinkContent () {
    if (this.validExternalLink()) {
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
      return
    }

    if (this.createModeFlag) {
      this.createExternalLinkContent()
    } else {
      this.updateExternalLink()
    }
  }

  private async createExternalLinkContent () {
    this.showLoading = true
    const requestBody: any = {
      external_link_id: this.externalLinkId,
      content_name: this.externalLinkContentName,
      record_date: this.createDateFormat(this.externalLinkContentDate),
      remarks: this.remarks,
      url: this.contentSelected === 1 ? this.contentURL : ''
    }

    const result = await ExternalLinkContentCreateApi.doExternalLinkContentCreate(requestBody, this.uploadFile)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: this.externalLinkTitle + '連携追加が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      const path = '/external-link/' + this.externalLinkId
      this.showLoading = false
      this.$router.push(path).catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      this.showLoading = false
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  private validExternalLink (): boolean {
    let isValid = false
    if (ExternalLinkContentValidator.validRequireExternalLinkContentName('externalLinkContentNameErrorMessage', this.externalLinkContentName)) {
      isValid = true
    }

    if (ExternalLinkContentValidator.validMaxLengthExternalLinkContentName('externalLinkContentNameMaxLengthErrorMessage', this.externalLinkContentName)) {
      isValid = true
    }

    if (ExternalLinkContentValidator.validRequiredContentDate('contentDateErrorMessage', this.externalLinkContentDate)) {
      isValid = true
    }

    if (this.contentSelected === 1 && ExternalLinkContentValidator.validRequireContentUrl('contentUrlErrorMessage', this.contentURL)) {
      isValid = true
    }

    if (this.contentSelected === 1 && ExternalLinkContentValidator.validMaxLengthContentUrl('contentUrlMaxLengthErrorMessage', this.contentURL)) {
      isValid = true
    }
    if (this.uploadFile !== null) {
      if (this.contentSelected === 0 && ExternalLinkContentValidator.validRequireContentFile('fileErrorMessage', this.uploadFile)) {
        isValid = true
      } else if (this.contentSelected === 0 && ExternalLinkContentValidator.validFileTypeContentFile('fileErrorMessage', this.uploadFile)) {
        isValid = true
      } else if (this.contentSelected === 0 && ExternalLinkContentValidator.validMaxFileSize('fileErrorMessage', this.uploadFile.size)) {
        isValid = true
      }
    } else {
      if (this.contentSelected === 0 && ExternalLinkContentValidator.validRequireContentFile('fileErrorMessage', this.fileName)) {
        isValid = true
      }
    }

    if (ExternalLinkContentValidator.validMaxLengthRemarks('remarksErrorMessage', this.remarks)) {
      isValid = true
    }

    this.errorMessages = Object.assign({}, this.errorMessages, ExternalLinkContentValidator.getErrorMessage())
    return isValid
  }

  private async updateExternalLink () {
    const requestBody: any = {
      content_name: this.externalLinkContentName,
      record_date: this.createDateFormat(this.externalLinkContentDate),
      remarks: this.remarks,
      url: this.contentSelected === 1 ? this.contentURL : '',
      time_stamp: this.externalLinkContentDetailData.time_stamp
    }

    if (this.contentSelected === 0 && this.fileName !== '') {
      if (this.uploadFile === null) {
        requestBody.file = await GetExternalLinkFileApi.getExternalLinkFileBlob(Number(this.externalLinkContentId))
      } else {
        requestBody.file = this.uploadFile
      }
    }

    const result = await ExternalLinkContentEditApi.doExternalLinkContentEdit(this.externalLinkContentId, requestBody, this.fileName)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: this.externalLinkTitle + '連携編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      const path = '/external-link/' + this.externalLinkId
      this.$router.push(path).catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  private getExternalLinkDetail (externalLinkId: string) {
    (async () => {
      const result = await ExternalLinkDetailApi.getDetail(externalLinkId)
      if (result.isOk()) {
        const payload = result.getPayload()
        this.externalLinkDetailData = payload
        this.externalLinkName = payload.external_link_name
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private getExternalLinkContentDetail (externalLinkContentId: string) {
    (async () => {
      const result = await ExternalLinkContentDetailApi.getDetail(externalLinkContentId)
      if (result.isOk()) {
        const payload = result.getPayload()
        this.externalLinkContentDetailData = payload.external_link_content
        this.externalLinkContentName = payload.external_link_content.content_name
        this.externalLinkContentDate = this.displayDate(payload.external_link_content.record_date)
        this.contentSelected = this.choiceContentType(payload.external_link_content.content_url)
        this.fileName = this.getFileName(payload.external_link_content.content_file)
        this.remarks = payload.external_link_content.remarks
        if (payload.external_link_content.content_url !== '') {
          this.contentURL = payload.external_link_content.content_url
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private getFileName (filePath: string): string {
    const filePathArr = filePath.split('/')
    return filePathArr[filePathArr.length - 1]
  }

  private doExternalLinkContentDelete () {
    (async () => {
      const result = await ExternalLinkContentDeleteApi.doExternalLinkContentDelete(this.externalLinkContentId)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: this.externalLinkTitle + '連携を削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        const path = '/external-link/' + this.externalLinkId
        this.$router.push(path).catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showConfirmationModal = false
    })()
  }

  private selectedFile (e: any) {
    e.preventDefault()
    const files = e.target.files
    this.uploadFile = files[0]
    this.fileName = this.uploadFile.name
  }

  private cancelFile (e: any) {
    e.preventDefault()
    this.fileName = ''
    this.uploadFile = null
    const file = document.getElementById('file')
    if (file !== null) {
      (file as HTMLInputElement).value = ''
    }
  }

  private createDateFormat (e: any) {
    const year = String(e.getFullYear())
    const month = '0' + String(e.getMonth() + 1)
    const day = '0' + String(e.getDate())
    return year + '-' + month.slice(-2) + '-' + day.slice(-2)
  }

  private displayDate (e: string): Date {
    const i = e.toString()
    const year = i.slice(0, 4)
    const month = i.slice(5, 7)
    const date = i.slice(8, 10)
    const monthInt = parseInt(month) - 1
    return new Date(Number(year), Number(monthInt), Number(date))
  }

  private choiceContentType (data: any): number {
    if (data !== '') {
      return 1
    } else {
      return 0
    }
  }

  private doCancel () {
    const path = '/external-link/' + this.externalLinkId
    this.$router.push(path).catch(e => {})
  }
}
